import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

function Loading() {
    return <div className="min-h-[60vh] flex items-center justify-center text-gold animate-flicker font-serif text-2xl">Lighting the candle…</div>;
}

export function ProtectedRoute({ children }) {
    const { user } = useAuth();
    if (user === null) return <Loading />;
    if (!user) return <Navigate to="/login" replace />;
    return children;
}

export function AdminRoute({ children }) {
    const { user } = useAuth();
    if (user === null) return <Loading />;
    if (!user || user.role !== "admin") return <Navigate to="/" replace />;
    return children;
}
